// Gatsby requirements
import React from 'react'
import { Link } from 'gatsby'

// Styles
import * as CSS from './Breadcrumb.module.scss'


const Breadcrumb = (data) => {

    return (
        <nav aria-label="breadcrumbs" className={CSS.crumbs}>
            
            <ol>
                <li><Link to="/">Home</Link></li>

                {data.slug1 && data.title1 &&
                    <li><Link to={`/${data.slug1}/`}>{data.title1}</Link></li>
                }
                {!data.slug1 && data.title1 &&
                    <li>{data.title1}</li>
                }
                {data.slug2 && data.title2 &&
                    <li><Link to={`/${data.slug2}/`}>{data.title2}</Link></li>
                }
                {!data.slug2 && data.title2 &&
                    <li>{data.title2}</li>
                }

                {data.title3 &&
                    <li>{data.title3}</li>
                }
            </ol>

        </nav>
    )
}

export default Breadcrumb